// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","header":"_2lvjn","clockIcon":"_37_k2","publicationDate":"_2Qz4U","updateDate":"_23w54"};